import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import ShowRecMsg from "./showRecMsg.vue";
import { getPayMap, getUserInfoMap } from "@/utils/dictionary";
import { getPayRequestOne } from "@/api/payItem";
export default {
  name: "showPayTable",
  components: {
    ShowRecMsg: ShowRecMsg
  },
  props: {
    tableInfo: Array
  },
  data: function data() {
    return {
      //获取所有角色列表（申请人与审批人）
      UserInfoList: "",
      PayInfoList: "",
      searchInfo: {},
      //点击表格的查看邮件的返回接收,弹出框
      dialogFormVisible: false,
      //传给查看的每一行数据
      formData: {},
      //true就是点击了编辑（只有审核驳回，才有这个按钮出现）
      isEditPage: false,
      aprStatus: {
        1: "待审批",
        2: "审批驳回",
        3: "审批通过"
      },
      aprClass: {
        1: "notApproved",
        2: "FailApproved",
        3: "Approved"
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, res1;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserInfoMap();
            case 2:
              res = _context.sent;
              _this.UserInfoList = res;
              _context.next = 6;
              return getPayMap();
            case 6:
              res1 = _context.sent;
              _this.PayInfoList = res1;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    checkPayBtn: function checkPayBtn(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.formData = row;
              console.log("this.formData", _this2.formData);
              _this2.dialogFormVisible = true;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    EditPayBtn: function EditPayBtn(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getPayRequestOne({
                id: row.id
              });
            case 2:
              res = _context3.sent;
              if (res.code == 0) {
                _this3.$emit("sendData", res.data);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getItemNameList: function getItemNameList(payItemId) {
      var _this4 = this;
      var ary = [];
      payItemId.split(',').forEach(function (itemId) {
        ary.push("".concat(itemId, " - ").concat(_this4.PayInfoList[itemId] || ''));
      });
      return ary;
    }
  }
};